<template lang="html">
    <div v-if="params && params.isActive">
        <ModalDefault
            size="m"
            :with-content="true"
            @close="params.isActive = false;"
            :theme="true"
            :fix-height="false"
            :fix-width="false"
            :loading="loading"
        >
            <template slot="main">
                <section class="delete-brand">
                    <p class="modal-title">{{ $trad.common.delete }}</p>
                    <p
                        v-html-safe="
                            $t('userrole.deleteFromBrand', {
                                user: params.user.firstname + ' ' + params.user.lastname,
                                brand: params.userBrand.brand.name.toUpperCase()
                            })
                        "
                    ></p>
                    <p>{{ $t("deleteBrand.messageAction") }}</p>
                    <div class="row d-flex justify-content-end">
                        <ClientColorButton :background-color="currentBrand.linksColor" @click="deleteBrand();" class="mr-3">{{
                            $trad.common.delete
                        }}</ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="params.isActive = false;">{{
                            $trad.common.cancel
                        }}</ClientColorButton>
                    </div>
                </section>
            </template>
        </ModalDefault>
    </div>
</template>

<script lang="js">
import connectionBO from '../../../services/connectionBO';
import ModalDefault from "@/components/ui/ModalDefault";
import {mapState} from "vuex";
import historyService from "@/services/history";
import {OBJECT_TYPE, SHORT_DESCRIPTION} from "@/components/history/constants";

export default {
    name: 'delete-brand',
    components: {ModalDefault},
    props: [
        'params'
    ],
    data() {
        return {
            loading: false
        }
    },
    methods: {
        deleteBrand () {
            const deletedUserBrand = {
                userBrand: [
                    {
                        id: this.params.userBrand.id,
                        brand: {
                            id: this.params.userBrand.brand.id,
                            name: this.params.userBrand.brand.name
                        }
                    }
                ]
            };
            this.loading = true;
            connectionBO.putBrandUser(this.params.user.id, deletedUserBrand).then(response => {
                if (response.code) {
                    console.error(response);
                    this.loading = false;
                    this.dialogError(response.code, "Code erreur : " + response.code, response.message.message);
                } else {
                    this.dialogSuccess(SHORT_DESCRIPTION.USER_DELETED.replace('{brand}', this.params.userBrand.brand.name.toUpperCase()));
                    this.loading = false;
                    this.params.isActive = false;
                    this.$emit('loadUsers');
                }
            });
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// DeleteBrand.vue?52b6b9a0